module.exports = __webpack_public_path__ + "img/dsci0032.4248ddfa.jpg";